/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SelectedProfile
 */
export interface SelectedProfile {
    /**
     * 
     * @type {string}
     * @memberof SelectedProfile
     */
    profileId: string;
    /**
     * The zero-based position of the result in the selection page.
     * @type {number}
     * @memberof SelectedProfile
     */
    position: number;
}

/**
 * Check if a given object implements the SelectedProfile interface.
 */
export function instanceOfSelectedProfile(value: object): value is SelectedProfile {
    if (!('profileId' in value) || value['profileId'] === undefined) return false;
    if (!('position' in value) || value['position'] === undefined) return false;
    return true;
}

export function SelectedProfileFromJSON(json: any): SelectedProfile {
    return SelectedProfileFromJSONTyped(json, false);
}

export function SelectedProfileFromJSONTyped(json: any, ignoreDiscriminator: boolean): SelectedProfile {
    if (json == null) {
        return json;
    }
    return {
        
        'profileId': json['profileId'],
        'position': json['position'],
    };
}

export function SelectedProfileToJSON(value?: SelectedProfile | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'profileId': value['profileId'],
        'position': value['position'],
    };
}

